export default __webpack_public_path__ + "static/media/MediumRectangle.df92b622.png";